<script>
import resources from './resources'

export default {
  name: 'professional-addresses-index',
  mixins: [resources]
}
</script>

<template lang="pug">
page(title=" Corpo Clínico  por Estabelecimento", icon="")
  .col-xs-12.content
    .container-fluid
      medibook-alert-custom(
        :show='show',
        @hide='show = false',
        message='Ainda não existe nenhum Local de Atendimento cadastrado',
        :buttonsNext='nextStepButtonStaffsAddress',
        v-if="!statusAddress && !statusCovenant")

      medibook-alert-custom(
        :show='show',
        @hide='show = false',
        message='Ainda não existe nenhum convênio cadastrado.',
        :buttonsNext='nextStepButtonStaffsCovenants',
        v-if="statusAddress && !statusCovenant")
      .row
        ul.nav.nav-tabs
          li.active
            a(href='#') Listagem
          li(v-if="!statusAddress")
            a.mb-cursor-point(@click="onShow()") Cadastro
            router-link(:to="{name: 'professional.company.staffs.create'}", v-if="statusAddress && statusCovenant")
              a(href="#") Cadastro

          li(v-if="statusAddress && !statusCovenant")
            a.mb-cursor-point(@click="onShow()") Cadastro
            router-link(:to="{name: 'professional.company.staffs.create'}", v-if="statusAddress && statusCovenant")
              a(href="#") Cadastro

        .col-xs-12.white-bg.wrapper(v-if="loading")
          .row.border-bottom-light
            spinner(:show="true")

        .col-xs-12.white-bg.wrapper(v-if="!loading")
          .row.border-bottom-light
            .col-sm-offset-8.col-sm-4
              form.col-sm-12
                .form-group.busca(style='margin-top:30px;')
                  .row
                    .col-xs-9
                      input#buscar.form-control(type='text', placeholder='Buscar Corpo Clínico')
                    .col-xs-3
                      button.search(type='submit')
                        span.icon 

            a.mb-cursor-point(v-if="!statusAddress && !statusCovenant", @click.prevent="onShow")
              .add-list.mb-cursor-point
                .icon-wrapper
                  span.icon 
                  .plus
                    span.icon 
                .text
                  | Novo<br>Corpo Clínico

            a.mb-cursor-point(v-if="statusAddress && !statusCovenant", @click.prevent="onShow")
              .add-list.mb-cursor-point
                .icon-wrapper
                  span.icon 
                  .plus
                    span.icon 
                .text
                  | Novo<br>Corpo Clínico

            card-add(label='Novo<br>Corpo Clínico', route='professional.company.staffs.create', icon='', v-if="statusAddress && statusCovenant")

            .list-item.white-bg.list-item.list-one-line(v-for=('staff in staffs'))
              .row.border-bottom
                h4.col-xs-7.col-sm-8 {{ staff.professional.name }}
                .col-xs-5.col-sm-4
                  .exclude-list(@click.prevent="doDelete(staff)")
                    span.icon 
                  router-link(:to="{name: getRouterEdit, params:{id: staff.id, professional: staff.professional_id}}")
                    a(href='#')
                      .edit-list
                        span.icon 
              .list-info
                template(v-for="speciality in staff.specialities")
                  strong {{ speciality.name }}
                  br

          .pagination
            pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/professional/company/staffs/index/index.vue